





























import Vue from 'vue'

export type DataType = {
}
export default Vue.extend({
  data(): DataType {
    return {
    }
  },
  computed: {
  },
})
